

// export default Chart;
import { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function Chart({ chart1 }) {

  const chartRef = useRef(null);

  useEffect(() => {
    let root = am5.Root.new(chartRef.current);
    root._logo.dispose();
    root.setThemes([am5themes_Animated.new(root)]);
    root.numberFormatter.setAll({
      numberFormat: "#", // removes decimal places
    });

    // Create a container for both the chart and legend
    let container = root.container.children.push(
      am5.Container.new(root, {
        layout: root.horizontalLayout,
        width: am5.percent(100),
        height: am5.percent(100),
      })
    );

    let chart = container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(65),
        startAngle: 180,
        endAngle: 360,
      })
    );

    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        alignLabels: false,
        startAngle: 180,
        endAngle: 360,
        radius: am5.percent(100),
      })
    );

    series.slices.template.adapters.add("fill", (fill, target) => {
      return am5.color(target.dataItem.dataContext.color);
    });

    series.slices.template.setAll({
      cornerRadius: 15,
      innerCornerRadius: 10,
      stroke: am5.color(0xffffff),
      strokeWidth: 2,
      tooltipText: "{category}: {value.formatNumber('#')}", // Format tooltip without decimal
    });

    series.labels.template.setAll({
      text: "{category}: {value.formatNumber('#')}",
      forceHidden: true,
    });

    series.data.setAll(chart1);

    // Legend setup
    let legend = container.children.push(
      am5.Legend.new(root, {
        layout: root.verticalLayout,
        centerY: am5.percent(50),
        y: am5.percent(50),
      })
    );

    // Make the legend marker circular
    legend.markers.template.setAll({
      width: 10,
      height: 10,
      cornerRadius: 50,
    });

    if (!legend.data.values.length) {
      legend.data.setAll(series.dataItems);
    }

    // ✅ Format legend labels without decimal
    legend.labels.template.setAll({
      text: "{category}: {value.formatNumber('#')}",
    });

    series.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [chart1]);

  return (
    <div
      id="chartdiv"
      ref={chartRef}
      style={{
        width: "100%",
        height: "275px",
        display: "flex",
        justifyContent: "center",
      }}
    />
  );
}

export default Chart;
